import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const SalesPortalCreateActivityReminderDocument = gql`
  mutation SalesPortalCreateActivityReminder(
    $crmActivityUUID: uuid!
    $chatUUID: uuid!
    $reminderDatetime: String!
  ) {
    createActivityReminder(
      activity_id: $crmActivityUUID
      chat_id: $chatUUID
      message: ""
      remind_at: $reminderDatetime
    ) {
      crm_activity_reminder {
        remind_at
        status
        uuid
      }
    }
  }
`;
export type SalesPortalCreateActivityReminderMutationFn =
  Apollo.MutationFunction<
    Types.SalesPortalCreateActivityReminderMutation,
    Types.SalesPortalCreateActivityReminderMutationVariables
  >;
export function useSalesPortalCreateActivityReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SalesPortalCreateActivityReminderMutation,
    Types.SalesPortalCreateActivityReminderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SalesPortalCreateActivityReminderMutation,
    Types.SalesPortalCreateActivityReminderMutationVariables
  >(SalesPortalCreateActivityReminderDocument, options);
}
export type SalesPortalCreateActivityReminderMutationHookResult = ReturnType<
  typeof useSalesPortalCreateActivityReminderMutation
>;
export type SalesPortalCreateActivityReminderMutationResult =
  Apollo.MutationResult<Types.SalesPortalCreateActivityReminderMutation>;
export type SalesPortalCreateActivityReminderMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SalesPortalCreateActivityReminderMutation,
    Types.SalesPortalCreateActivityReminderMutationVariables
  >;
